import type { AplPosition } from '../types/apl-position-types'
import { slugify } from './string'

const POSITION_ICON_BASE_PATH = '/position-icons'
const POSITION_HERO_BASE_PATH = '/apl/positions/hero'

export const DEFAULT_POSITION_ICON_URL = `${POSITION_ICON_BASE_PATH}/default.svg`

const CATEGORY_ASSET_MAP: Record<string, string> = {
  'bodily-autonomy': 'healthcare',
  'care-economy': 'healthcare',
  'civic-literacy': 'education',
  'clean-airenergy': 'clean-air',
  'democracy--voting-rights': 'education',
  'digital-rights': 'education',
  'education--workforce': 'education',
  'equal-rights--lgbtq': 'equal-standing',
  'food': 'food',
  'global-health': 'healthcare',
  'healthcare': 'healthcare',
  'homes': 'homes',
  'immigration': 'equal-standing',
  'indigenous-rights': 'equal-standing',
  'kids': 'healthcare',
  'nature--living-systems': 'healthcare',
  'poverty-reduction': 'education',
  'press-freedom': 'education',
  'prevention--public-health': 'healthcare',
  'safety': 'safety',
  'sustainable-commerce': 'safety',
  'taxes--revenue': 'education',
  'water': 'clean-water',
  'worker-power': 'equal-standing'
}

const HERO_ASSET_MAP: Record<string, string> = {
  homes: 'home'
}

export const getPositionCategoryAssetKey = (position?: AplPosition | null) => {
  const slug = position?.category?.slug?.current
  if (slug) return CATEGORY_ASSET_MAP[slug] || slug

  const categoryName = position?.category?.name || position?.category?.title
  if (categoryName) {
    const nameSlug = slugify(categoryName)
    return CATEGORY_ASSET_MAP[nameSlug] || nameSlug
  }
}

export const getPositionIconSrc = (position?: AplPosition | null) => {
  if (!position) return DEFAULT_POSITION_ICON_URL

  const categoryAssetKey = getPositionCategoryAssetKey(position)
  return (
    position.iconUrl ||
    position.icon?.asset?.url ||
    (categoryAssetKey ? `${POSITION_ICON_BASE_PATH}/${categoryAssetKey}.svg` : undefined) ||
    DEFAULT_POSITION_ICON_URL
  )
}

export const getPositionHeroSrc = (
  position: AplPosition | null | undefined,
  side: 'left' | 'right'
) => {
  const categoryAssetKey = getPositionCategoryAssetKey(position)
  const heroAssetKey =
    (categoryAssetKey && HERO_ASSET_MAP[categoryAssetKey]) || categoryAssetKey || 'default'
  return `${POSITION_HERO_BASE_PATH}/${heroAssetKey}-${side}.svg`
}
